import { INTRANET_CONTENT_KIND_LABELS, INTRANET_LIBRARY_KINDS } from '@gb-ticket/shared-types';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

const ALL = 'all';

function selected(value: string | undefined): string {
  if (!value) {
    return ALL;
  }
  return value;
}

export function KnowledgeNarrowing({
  kind,
  onKind,
  manufacturerId,
  manufacturers,
  onManufacturer,
  categoryId,
  categories,
  onCategory,
}: {
  kind?: string;
  onKind: (kind: string) => void;
  manufacturerId?: string;
  manufacturers: readonly { id: string; name: string }[];
  onManufacturer: (manufacturerId: string) => void;
  categoryId?: string;
  categories?: readonly { id: string; name: string; parent: { name: string } | null }[];
  onCategory?: (categoryId: string) => void;
}) {
  return (
    <>
      <label className="flex min-w-0 flex-col gap-1 text-xs sm:text-sm">
        <span className="text-muted-foreground">Inhaltsart</span>
        <Select
          value={selected(kind)}
          onValueChange={(value) => onKind(value === ALL ? '' : value)}
        >
          <SelectTrigger aria-label="Inhaltsart" size="sm" className="w-full min-w-0 lg:w-36">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value={ALL}>Alle Arten</SelectItem>
            {INTRANET_LIBRARY_KINDS.map((entry) => (
              <SelectItem key={entry} value={entry}>
                {INTRANET_CONTENT_KIND_LABELS[entry]}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </label>
      {onCategory ? (
        <label className="flex min-w-0 flex-col gap-1 text-xs sm:text-sm">
          <span className="text-muted-foreground">Kategorie</span>
          <Select
            value={selected(categoryId)}
            onValueChange={(value) => onCategory(value === ALL ? '' : value)}
          >
            <SelectTrigger aria-label="Kategorie" size="sm" className="w-full min-w-0 lg:w-36">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value={ALL}>Alle Kategorien</SelectItem>
              {(categories ?? []).map((category) => (
                <SelectItem key={category.id} value={category.id}>
                  {category.parent ? `${category.parent.name} / ${category.name}` : category.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </label>
      ) : null}
      <label className="flex min-w-0 flex-col gap-1 text-xs sm:text-sm">
        <span className="text-muted-foreground">Hersteller</span>
        <Select
          value={selected(manufacturerId)}
          onValueChange={(value) => onManufacturer(value === ALL ? '' : value)}
        >
          <SelectTrigger aria-label="Hersteller" size="sm" className="w-full min-w-0 lg:w-36">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value={ALL}>Alle Hersteller</SelectItem>
            {manufacturers.map((manufacturer) => (
              <SelectItem key={manufacturer.id} value={manufacturer.id}>
                {manufacturer.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </label>
    </>
  );
}
